"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _RecentActivityHeaderWithFilter = _interopRequireDefault(require("./RecentActivityHeaderWithFilter"));
var _RecentActivityTableWithFilter = _interopRequireDefault(require("./RecentActivityTableWithFilter"));
require("../RecentActivity/ActivityComponents.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var RecentActivityWithFilterComponent = function RecentActivityWithFilterComponent(props) {
  var width = props.width,
    themeModifier = props.themeModifier,
    pageSize = props.pageSize,
    minRow = props.minRow,
    filterForSelected = props.filterForSelected;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_RecentActivityHeaderWithFilter["default"], null), /*#__PURE__*/_react["default"].createElement(_RecentActivityTableWithFilter["default"], {
    filterForSelected: filterForSelected,
    pageSize: pageSize,
    minRow: minRow,
    themeModifier: themeModifier,
    width: width
  }));
};
var _default = exports["default"] = RecentActivityWithFilterComponent;